// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1fAlc","empty":"ModalGraph_empty__25aDj"};